import { create } from "zustand"
import type { RfqTarget } from "@/components/dashboard/buyer/pages/SubmitRfqPage"

interface FindSupplierState {
  // Search Inputs
  inputValue: string
  searchQuery: string
  
  // Selection States
  isMultiSelectActive: boolean
  selectedCompanyIds: string[]
  
  // Form states for in-page RFQs (e.g. quick RFQ / company details RFQ / product details RFQ)
  activeCompanyRfqTarget: RfqTarget
  companyQueryMessage: string
  companyQuantity: number | ""
  
  activeProductRfqTarget: RfqTarget
  productQueryMessage: string
  productQuantity: number | ""

  companyFilters: any
  productFilters: any
  hasSearchResults: boolean
  
  // Actions
  setInputValue: (value: string) => void
  setSearchQuery: (query: string) => void
  setIsMultiSelectActive: (active: boolean) => void
  setSelectedCompanyIds: (ids: string[] | ((prev: string[]) => string[])) => void
  
  setActiveCompanyRfqTarget: (target: RfqTarget) => void
  setCompanyQueryMessage: (msg: string) => void
  setCompanyQuantity: (qty: number | "") => void
  
  setActiveProductRfqTarget: (target: RfqTarget) => void
  setProductQueryMessage: (msg: string) => void
  setProductQuantity: (qty: number | "") => void
  setCompanyFilters: (filters: any) => void
  setProductFilters: (filters: any) => void
  setHasSearchResults: (hasResults: boolean) => void
  
  clearStore: () => void
}

export const useFindSupplierStore = create<FindSupplierState>((set) => ({
  inputValue: "",
  searchQuery: "",
  
  isMultiSelectActive: false,
  selectedCompanyIds: [],
  
  activeCompanyRfqTarget: null,
  companyQueryMessage: "",
  companyQuantity: "",
  
  activeProductRfqTarget: null,
  productQueryMessage: "",
  productQuantity: "",
  companyFilters: {},
  productFilters: {},
  hasSearchResults: false,

  setInputValue: (inputValue) => set({ inputValue }),
  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setIsMultiSelectActive: (isMultiSelectActive) => set({ isMultiSelectActive }),
  setSelectedCompanyIds: (ids) => set((state) => ({
    selectedCompanyIds: typeof ids === "function" ? ids(state.selectedCompanyIds) : ids
  })),
  
  setActiveCompanyRfqTarget: (activeCompanyRfqTarget) => set({ activeCompanyRfqTarget }),
  setCompanyQueryMessage: (companyQueryMessage) => set({ companyQueryMessage }),
  setCompanyQuantity: (companyQuantity) => set({ companyQuantity }),
  
  setActiveProductRfqTarget: (activeProductRfqTarget) => set({ activeProductRfqTarget }),
  setProductQueryMessage: (productQueryMessage) => set({ productQueryMessage }),
  setProductQuantity: (productQuantity) => set({ productQuantity }),
  setCompanyFilters: (companyFilters) => set({ companyFilters }),
  setProductFilters: (productFilters) => set({ productFilters }),
  setHasSearchResults: (hasSearchResults) => set({ hasSearchResults }),
  
  clearStore: () => set({
    inputValue: "",
    searchQuery: "",
    isMultiSelectActive: false,
    selectedCompanyIds: [],
    activeCompanyRfqTarget: null,
    companyQueryMessage: "",
    companyQuantity: "",
    activeProductRfqTarget: null,
    productQueryMessage: "",
    productQuantity: "",
    companyFilters: {},
    productFilters: {},
    hasSearchResults: false,
  })
}))
